import { render, staticRenderFns } from "./EmbeddingScatterChart.vue?vue&type=template&id=1c37baeb&scoped=true&"
import script from "./EmbeddingScatterChart.vue?vue&type=script&lang=js&"
export * from "./EmbeddingScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c37baeb",
  null
  
)

export default component.exports